import {TalonState} from '../reducers/talon';
import {safelyToJS} from './utils';

export const selectTalon = (state): TalonState => safelyToJS(state.get('talon'));
